import * as Types from '../../graphql.generated';

import gql from 'graphql-tag';
import * as Apollo from '@apollo/client';
const defaultOptions = {};
export type DeleteTrackedPropertyMutationVariables = Types.Exact<{
    propertyId?: Types.Maybe<Types.Scalars['String']>;
    uprn?: Types.Maybe<Types.Scalars['String']>;
}>;

export type DeleteTrackedPropertyMutation = { __typename?: 'Mutation' } & Pick<
    Types.Mutation,
    'deleteTrackedProperty'
>;

export const DeleteTrackedPropertyDocument = gql`
    mutation deleteTrackedProperty($propertyId: String, $uprn: String) {
        deleteTrackedProperty(propertyId: $propertyId, uprn: $uprn)
    }
`;
export type DeleteTrackedPropertyMutationFn = Apollo.MutationFunction<
    DeleteTrackedPropertyMutation,
    DeleteTrackedPropertyMutationVariables
>;

/**
 * __useDeleteTrackedPropertyMutation__
 *
 * To run a mutation, you first call `useDeleteTrackedPropertyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTrackedPropertyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTrackedPropertyMutation, { data, loading, error }] = useDeleteTrackedPropertyMutation({
 *   variables: {
 *      propertyId: // value for 'propertyId'
 *      uprn: // value for 'uprn'
 *   },
 * });
 */
export function useDeleteTrackedPropertyMutation(
    baseOptions?: Apollo.MutationHookOptions<
        DeleteTrackedPropertyMutation,
        DeleteTrackedPropertyMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation<
        DeleteTrackedPropertyMutation,
        DeleteTrackedPropertyMutationVariables
    >(DeleteTrackedPropertyDocument, options);
}
export type DeleteTrackedPropertyMutationHookResult = ReturnType<
    typeof useDeleteTrackedPropertyMutation
>;
export type DeleteTrackedPropertyMutationResult =
    Apollo.MutationResult<DeleteTrackedPropertyMutation>;
export type DeleteTrackedPropertyMutationOptions = Apollo.BaseMutationOptions<
    DeleteTrackedPropertyMutation,
    DeleteTrackedPropertyMutationVariables
>;
